import type { IPageContext } from './page-context';
import type { TargetDataModel } from './base-context';
import type { ISlideDataModel } from '../model/slide-data-model';
import type { ILayoutDataModel } from '../model/layout-data-model';
import type { IMasterDataModel } from '../model/master-data-model';
import type { INoteSlideDataModel } from '../model/note-slide-data-model';
import type { INotesMasterDataModel } from '../model/notes-master-data-model';
import type { DeepReadonly } from 'ts-essentials';
import type { ICTPlaceholderPml } from '@tencent/slide-sdk-pb-model';

export class BaseShapeContext implements IPageContext {
    private target?: TargetDataModel;

    public constructor(private parent: IPageContext) {}

    public setTarget(target: TargetDataModel) {
        this.target = target;
    }

    public getTarget() {
        return this.target;
    }

    public getPageType() {
        return this.parent.getPageType();
    }

    public getPage<
        Page extends
            | ISlideDataModel
            | ILayoutDataModel
            | IMasterDataModel
            | INoteSlideDataModel
            | INotesMasterDataModel,
    >() {
        return this.parent.getPage<Page>();
    }

    public getSlide() {
        return this.parent.getSlide();
    }

    public getLayout() {
        return this.parent.getLayout();
    }

    public getMaster() {
        return this.parent.getMaster();
    }

    public getTheme() {
        return this.parent.getTheme();
    }

    public getThemeContext() {
        return this.parent.getThemeContext();
    }

    public getPlaceholder(ph?: DeepReadonly<ICTPlaceholderPml>) {
        return this.parent.getPlaceholder(ph);
    }

    public getPresentation() {
        return this.parent.getPresentation();
    }
}
